import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { PageLoader } from "./Spinner";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <PageLoader label="Authenticating…" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && profile?.role !== "admin") return <Navigate to="/dashboard" replace />;

  return children;
}
